"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = function () { };
__export(require("./castTouchToMouseEvent"));
__export(require("./detectMouseButton"));
__export(require("./doObjectsCollide"));
__export(require("./getBoundsForNode"));
__export(require("./nodeInRoot"));
//# sourceMappingURL=index.js.map